import React from "react";
import UpdateGroup from "pages/group/groupSettings/UpdateGroup";
import styled from "@emotion/styled";
import {AboutGroup} from 'pages/group/groupSettings/AboutGroup';
import {useSelector} from "react-redux";
import {getCurrentLeague, getCurrentUserId} from "modules/selectors";
import {eq} from "lodash-es";

const Wrapper = styled.div`
	display: flex;
	gap: 20px;
	flex: 1;
	& > div {
		&:first-of-type {
			flex: auto;
			width: 100%;
		}
	}

	@media (max-width: 1150px) {
		flex-flow: column;
	}
`;
const GroupSettings: React.FC = () => {
	const currentLeague = useSelector(getCurrentLeague);
	const userID = useSelector(getCurrentUserId);
	const isCommissioner = eq(currentLeague?.userId, userID);

	return <Wrapper>{isCommissioner ? <UpdateGroup /> : <AboutGroup />}</Wrapper>;
};

export default GroupSettings;
